export enum TrainingType {
    ERT = 1,
    Other = 2,
    Specialty = 3,
  }